import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    const options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        arbitrageDistribution: [
          entity?.parameters?.arbitrageDistribution || null,
          [Validators.required],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products.map((product, index) => {
      const originalDistribution =
        this.entity?.products?.[index]?.parameters?.arbitrageDistribution;
      const currentDistribution = product.parameters?.arbitrageDistribution;

      if (
        originalDistribution &&
        currentDistribution !== originalDistribution
      ) {
        return {
          ...product,
          parameters: {
            ...product.parameters,
            supportsInvestmentStock: [],
            supportsInvestmentFlux: [],
            productPackId: null,
          },
        };
      }

      return product;
    });
  }
}
